import RightContent from 'app/components/layouts/MenuRight/RightContent';
import { useEffect, useMemo, useState } from 'react';
import { findTranslate } from 'app/utils/translate';
import Image from 'app/components/layouts/Image';
import * as grammarApi from 'app/requests/grammars';
import { useTranslation } from 'next-i18next';
import * as indexDb from 'app/utils/indexDb';
import { useRouter } from "next/router";
import { Blog } from 'types/blog';
import Link from 'next/link';

const Grammar = () => {
  const [grammars, setGrammars] = useState<Blog[]>([]);
  const { t } = useTranslation('common');
  const router = useRouter();

  const fetchGrammar = async () => {
    const params = { code: router?.locale, type: 'tense' };
    // const key = `grammars_${router?.locale}_tense`;
    // let items = await indexDb.getItem(key);

    // if (!items) {
    //   items = await grammarApi.getGrammars(params);
    //   await indexDb.setItem(key, items);
    // }
    const items = await grammarApi.getGrammars(params);
    setGrammars(items);
  }

  useEffect(() => {
    if (window.innerWidth > 992) {
      fetchGrammar();
    }
  }, [router?.locale]);

  const contentRight = useMemo(() => {
    return <div className="d-flex justify-content-center flex-wrap">
      {
        (grammars || []).map((grammar: Blog, index) => {
          return (
            <Link className="grammar" key={index} href={`/grammar/${grammar[`slug_${router?.locale}`]}`}>
              <Image
                src={`/images/grammar/${grammar?.grammar_type?.icon}`}
                alt=""
              />
              <span className='text-left text-info pr-1'>
                {findTranslate(grammar.translates, 'title', router?.locale)}
              </span>
            </Link>
          )
        })
      }
    </div>
  }, [grammars]);

  return (
    <RightContent
      title={t('grammar.title')}
      contentRight={contentRight}
    />
  )
}

export default Grammar;
